<nav class="navbar navbar-expand-lg " style="background-color: #002E5E;padding: 0px; height: 45px;">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <h3 class="mb-0"><img src="assets/images/nextgen-logo.png" width="275px" height="16px" alt="Next Gen Digital Imaging logo" />
        <div class="sysnamestyle">{{'- '}}{{selectedSystemName}}</div>
      </h3>
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
      aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item dropdown" style="border-left: 1px solid #617b96;">
          <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="material-icons">
              account_circle
            </span> Welcome {{userFullName}}
          </button>
          <ul class="dropdown-menu">
            <li><button class="dropdown-item" (click)="openUserPreferenceDialog()"><span class="material-icons"> settings
                </span>User Preference</button></li>
            <li><button class="dropdown-item" (click)="openUserSubstitutionDialog()"><span class="material-icons"> person_add_alt_1
                </span>User Substitution</button></li>
            <li><button class="dropdown-item"><span class="material-icons">contact_mail</span>Spa Box Mapping</button>
            </li>
            <li><button class="dropdown-item" href="javascript:void(0)" (click)="popPermission()"><span
                  class="material-icons">lock</span>Permission</button></li>
            <li><button class="dropdown-item" href="javascript:void(0)" (click)="signOut()"><span
                  class="material-icons">logout</span>Logout</button></li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <button class="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <span class="material-icons"> settings </span>
          </button>
          <ul class="dropdown-menu">
            <li><button class="dropdown-item" (click)="openUserSystemDialog()"><span class="material-icons"> wysiwyg
                </span>Change system</button></li>
          </ul>
        </li>
        <li class="nav-item dropdown">
          <button class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false" (keydown)="onKeyDown($event)">
            <span class="material-icons"> question_mark </span>
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="{{userGuideUrl}}" target="_blank"><span
                  class="material-icons">assignment</span>User Guide</a></li>
            <li><a class="dropdown-item" (click)="openContact()"><span class="material-icons">contact_mail</span>Contact
                Us</a></li>
          </ul>
        </li>
        <li class="nav-item pepsico-logo">
          <img src="assets/images/Pepsico-logo-header.png" width="100px" height="auto" alt="PepsiCo logo"/>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="row">
  <div class="main-content-wrapper">
    <div class="main-content">
      <div class="menu_tabs">
        <!-- Tab Headers -->
        <div class="tab-headers" *ngIf="isActive()">
          <div *ngFor="let tab of tabs; let i = index">
            <button [routerLink]="tab.route" routerLinkActive="active-tab" [routerLinkActiveOptions]="{ exact: true }" (click)="handleRegisterPrincipal()">
              {{ tab.title }}
            </button>
          </div>
        </div>
        <div class="tab-divider"></div>
        <div class="tab-content" [ngClass]="{ 'active-body': isActive() }">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
 
<div *ngIf="showWarning" class="idle-warning-banner">
  <div class="banner-header">
    IDLE TIMEOUT WARNING
  </div>
  <div class="banner-body">
    <p>You have been inactive for <strong>{{ idleMinutes }}</strong> minutes.</p>
    <p>For security reasons, if there is no activity in the next <strong>{{ timeoutMinutes }}</strong> minutes, you will
      be logged out automatically.</p>
    <div class="timer-container">
      <h2>{{ formatCountdown(countdown) }}</h2>
      <div class="progress-bar-wrapper">
        <mat-progress-bar class="custom-progress-bar" mode="determinate" [value]="progressBarValue"
          color="warn"></mat-progress-bar>
      </div>
    </div>
  </div>
</div>
<!-- Message bar just above footer -->
<div *ngIf="footerMessage" [ngClass]="messageType" class="footer-message">
  {{ footerMessage }}
  <button type="button" (click)="closeFooterMessage()" aria-label="Close message" class="footer-close-btn">
    &times;
  </button>
</div>
<!-- Footer -->
<footer class="footer">
  <div class="container">
    © {{ currentYear }} Next Gen Digital Imaging System. All rights reserved.
  </div>
</footer>